export const GOOGLE_CALENDAR_API_KEY = 'AIzaSyAGMA7x4YMgXyEo1SvStY8Rm0x0jOj8AgI';
export const GOOGLE_CALENDAR_ID = 'c_10fomfvgafp5atjgb2t8i190i4@group.calendar.google.com';